import { useCallback, useEffect, useRef } from "react";
import { useAuraSupportInfo } from "../UseAuraInfoContext";
import { InfoMessageType } from "src/SharedComponents/InfoBar/InfoBar";
import { AddLicenseType, LicenseType, useDistributorLicenseService } from "./useDistributorLicenseService";
import { logger } from "src/Utils/LoggerService/LoggerService";

export const useDistributorLicenseServiceWrapper = () => {
    const { assignLicenseToPartner, unassignLicenseFromPartner, addLicenseToClinic, reqestError, reqestLoading, reqestResponse , addLicenseToPartner} = useDistributorLicenseService();
    const { setInfobar, setLoader, reset } = useAuraSupportInfo();
    const infoMessage = useRef('');
    const distributorid = useRef('');
    useEffect(() => {
        if(reqestError !== '') {
           logger.logError(JSON.stringify(reqestError))
           setInfobar({message:reqestError,messageType: InfoMessageType.error })
        }
    }, [reqestError, setInfobar])
    useEffect(() => {
       setLoader(reqestLoading)
    },[reqestLoading, setLoader])
    
    useEffect(() => {
       if(reqestResponse) {
        logger.logInformation(infoMessage.current + `Distributor Id is ${distributorid.current}`)
        setInfobar({message:infoMessage.current, messageType: InfoMessageType.success})
       }
    }, [reqestResponse, setInfobar])

    const assignLicensePartner = useCallback((licenseType: LicenseType, distributorId:string, entitlementId:string[], distributorName: string) => {
        reset();
        distributorid.current = distributorId;
        assignLicenseToPartner(entitlementId, distributorId);
        if(licenseType === LicenseType.AuraAppLicenses){
            if(entitlementId.length === 1){
                infoMessage.current = `Aura App License "${entitlementId[0]}" is successfully assigned to Partner "${distributorName}".`;
            }
            else{
                infoMessage.current = `${entitlementId.length} Aura App Licenses successfully assigned to Partner "${distributorName}".`;
            }
        }
        else if(licenseType === LicenseType.CloudStorageLicenses) {
            infoMessage.current = `Cloud Storage License "${entitlementId}" is successfully assigned to Partner "${distributorName}".`;
        }
        else {
            infoMessage.current = `Aura Software Suite "${entitlementId}" is successfully assigned to Partner "${distributorName}".`;
        }
    },[assignLicenseToPartner, reset]) 

    const unassignLicensePartner = useCallback((distributorId:string, entitlementId:string, distributorName: string) => {
        reset();
        distributorid.current = distributorId;
        unassignLicenseFromPartner(entitlementId, distributorId);
        infoMessage.current = `Aura App License "${entitlementId}" is successfully unassigned from Partner "${distributorName}".`;
    },[unassignLicenseFromPartner, reset]) 

    const assignTrailDemoLicenseToClinic = useCallback((licenseType: AddLicenseType, clinicId: string, clinicName: string, seatCount: number) => {
        reset();
        addLicenseToClinic(licenseType, clinicId, seatCount);
        infoMessage.current = `License for ${licenseType} is assigned to clinic: ${clinicName} successfully`;
    }, [addLicenseToClinic, reset])

    const assignTrailDemoLicenseToPartner = useCallback((licenseType: AddLicenseType, distributorId: string, distributorName: string, seatCount: number) => {
        reset();
        addLicenseToPartner(licenseType, distributorId, seatCount);
        infoMessage.current = `License for ${licenseType} is assigned to distributor: ${distributorName} successfully`;
    }, [addLicenseToPartner, reset])

    return {reqestResponse, reqestError, assignLicensePartner, unassignLicensePartner, assignTrailDemoLicenseToClinic, assignTrailDemoLicenseToPartner}
} 